export const restartApp = async () => {
    if (typeof global === "undefined") {
        // browser app reload
        window.location.reload();
    } else if (process.platform === "win32") {
        // nwjs win32 app reload
        const child = require("child_process").spawn(
            process.execPath,
            require('nw.gui').App.argv, {
            cwd: require('path').dirname(process.cwd()),
            detached: true,
            stdio: "inherit"
        });
        //Don't wait for it
        child.unref();
        require('nw.gui').App.quit();
    } else {
        // nwjs other app reload
        nw.Window.get().reload();
    }
}
